// extracted by mini-css-extract-plugin
export default {"changeLink":"BQ-z","disabled":"CQ-z","inline":"DQ-z"};